import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

import backgroundIllustration from "../assets/couple.png";
import logo from "../assets/logo.png";
import "../css/Login.css";

function ResetPassword() {
    // Translation
    const { t } = useTranslation();

    // Get reset token from URL
    const { token } = useParams();

    // Navigation
    const navigate = useNavigate();

    // Form state
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    // Password visibility
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // Message + loading
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check passwords match
        if (password !== confirmPassword) {
            setMessage(t("resetPassword.passwordMismatch"));
            return;
        }

        setLoading(true);
        setMessage("");

        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
                {
                    token,
                    password,
                }
            );

            setMessage(t("resetPassword.success"));

            // Go to login after 2 seconds
            setTimeout(() => {
                navigate("/login");
            }, 2000);

        } catch (err) {
            console.error("Reset password error:", err);

            setMessage(t("resetPassword.error"));

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="conteneur-connexion">

            <div className="carte-connexion">

                {/* =========================
                    LEFT SIDE
                ========================== */}
                <div className="cote-gauche">

                    <img
                        src={backgroundIllustration}
                        alt={t("resetPassword.coupleAlt")}
                        className="image-connexion"
                    />

                    <div className="overlay-connexion">
                        <h2>
                            {t("resetPassword.heroTitle")}
                        </h2>

                        <p>
                            {t("resetPassword.heroSubtitle")}
                        </p>
                    </div>

                </div>


                {/* =========================
                    RIGHT SIDE
                ========================== */}
                <div className="cote-droit">

                    {/* Logo + Title */}
                    <div className="en-tete-connexion">

                        <img
                            src={logo}
                            alt="MyHalal"
                            className="logo-connexion"
                        />

                        <h2>
                            {t("resetPassword.title")}
                        </h2>

                    </div>


                    {/* Error / Success Message */}
                    {message && (
                        <div className="erreur-connexion">
                            {message}
                        </div>
                    )}


                    {/* =========================
                        RESET PASSWORD FORM
                    ========================== */}
                    <form
                        onSubmit={handleSubmit}
                        className="formulaire-connexion"
                    >

                        {/* New Password */}
                        <div className="groupe-input">

                            <FaLock className="icone-input" />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                placeholder={t(
                                    "resetPassword.newPassword"
                                )}
                                value={password}
                                onChange={(e) =>
                                    setPassword(e.target.value)
                                }
                                required
                            />

                            <button
                                type="button"
                                className="bouton-visibilite"
                                onClick={() =>
                                    setShowPassword(
                                        !showPassword
                                    )
                                }
                                aria-label={
                                    showPassword
                                        ? t("resetPassword.hidePassword")
                                        : t("resetPassword.showPassword")
                                }
                            >
                                {showPassword
                                    ? <FaEyeSlash />
                                    : <FaEye />
                                }
                            </button>

                        </div>


                        {/* Confirm Password */}
                        <div className="groupe-input">

                            <FaLock className="icone-input" />

                            <input
                                type={
                                    showConfirmPassword
                                        ? "text"
                                        : "password"
                                }
                                placeholder={t(
                                    "resetPassword.confirmPassword"
                                )}
                                value={confirmPassword}
                                onChange={(e) =>
                                    setConfirmPassword(
                                        e.target.value
                                    )
                                }
                                required
                            />

                            <button
                                type="button"
                                className="bouton-visibilite"
                                onClick={() =>
                                    setShowConfirmPassword(
                                        !showConfirmPassword
                                    )
                                }
                                aria-label={
                                    showConfirmPassword
                                        ? t("resetPassword.hidePassword")
                                        : t("resetPassword.showPassword")
                                }
                            >
                                {showConfirmPassword
                                    ? <FaEyeSlash />
                                    : <FaEye />
                                }
                            </button>

                        </div>


                        {/* Update Password Button */}
                        <button
                            type="submit"
                            className="bouton-connexion"
                            disabled={loading}
                        >
                            {loading
                                ? t("resetPassword.updating")
                                : t("resetPassword.updatePassword")
                            }
                        </button>

                    </form>

                </div>

            </div>

        </div>
    );
}

export default ResetPassword;